function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { AnchoredNotification, Notification } from "./Notification";
export var AnchoredNotificationInfo = function AnchoredNotificationInfo(props) {
  return /*#__PURE__*/React.createElement(AnchoredNotification, _extends({
    status: "info"
  }, props));
};
export var AnchoredNotificationAlert = function AnchoredNotificationAlert(props) {
  return /*#__PURE__*/React.createElement(AnchoredNotification, _extends({
    status: "alert"
  }, props));
};
export var AnchoredNotificationWarning = function AnchoredNotificationWarning(props) {
  return /*#__PURE__*/React.createElement(AnchoredNotification, _extends({
    status: "warning"
  }, props));
};
export var AnchoredNotificationSuccess = function AnchoredNotificationSuccess(props) {
  return /*#__PURE__*/React.createElement(AnchoredNotification, _extends({
    status: "success"
  }, props));
};
export var NotificationInfo = function NotificationInfo(props) {
  return /*#__PURE__*/React.createElement(Notification, _extends({
    status: "info"
  }, props));
};
export var NotificationAlert = function NotificationAlert(props) {
  return /*#__PURE__*/React.createElement(Notification, _extends({
    status: "alert"
  }, props));
};
export var NotificationWarning = function NotificationWarning(props) {
  return /*#__PURE__*/React.createElement(Notification, _extends({
    status: "warning"
  }, props));
};
export var NotificationSuccess = function NotificationSuccess(props) {
  return /*#__PURE__*/React.createElement(Notification, _extends({
    status: "success"
  }, props));
};